import { h, render } from 'preact';
import mountExternalAds from '~/components/ExternalAd/mount';
import { Ad } from '~/shared/containers/Ad';

function category() {
  render(<Ad slot="category" />, document.getElementById('custom-ad-slot'));
}
category();
mountExternalAds();
